/**
 * Per-map POI slice for Explore Unknown (React client copy).
 *
 * Canonical implementation lives at `modules/exploreUnknownMapSlice.js` on the
 * server. This file is a byte-identical duplicate because Create React App
 * cannot import from outside `React/src/`. Keep both files in sync;
 * `__tests__/regression/ExploreUnknown_MapSlice_Parity_Regression.js`
 * enforces functional parity on CI.
 *
 * Global mission indices: mapOffset + i for i = 1..localCount.
 *
 * @param {number[]} completedIndices
 * @param {number | null} nextAvailable
 * @param {number} mapOffset 0 for missions 1–5, 5 for 6–10, etc.
 * @param {number} localCount
 * @returns {('done'|'available'|'unavailable')[]}
 */
function computeMapSlicePointStates(completedIndices, nextAvailable, mapOffset, localCount) {
  if (!Array.isArray(completedIndices)) {
    throw new Error('computeMapSlicePointStates: completedIndices must be an array');
  }
  if (!Number.isInteger(mapOffset) || mapOffset < 0) {
    throw new Error('computeMapSlicePointStates: mapOffset must be a non-negative integer');
  }
  if (!Number.isInteger(localCount) || localCount < 1) {
    throw new Error('computeMapSlicePointStates: localCount must be a positive integer');
  }
  const completed = new Set(completedIndices);
  const out = [];
  for (let i = 1; i <= localCount; i += 1) {
    const globalIdx = mapOffset + i;
    if (completed.has(globalIdx)) out.push('done');
    else if (nextAvailable === globalIdx) out.push('available');
    else out.push('unavailable');
  }
  return out;
}

module.exports = { computeMapSlicePointStates };
